var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"height":"590px"}},_vm._l((_vm.banners),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.img}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }